const scriptsCache = {};

export function createScript(src: string): HTMLScriptElement | undefined {
  if (scriptsCache[src]) {
    return;
  }

  const script = window.document.createElement('script');

  script.src = src;
  script.type = 'text/javascript';
  script.async = true;

  scriptsCache[src] = src;

  return script;
}
